import { render, staticRenderFns } from "./carouselItem.vue?vue&type=template&id=6c197735"
import script from "./carouselItem.vue?vue&type=script&lang=js"
export * from "./carouselItem.vue?vue&type=script&lang=js"
import style0 from "./carouselItem.vue?vue&type=style&index=0&id=6c197735&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports